import { connect } from 'react-redux';
import App from '../components/App';
import { logout } from '../store/actions/auth';
import { dismissError, dismissLoadingSucceeded, isLoading } from '../store/actions/app';
import { getUrlParameter } from '../util';

const mapStateToProps = state => {

    return {
        context:            getUrlParameter( 'context' ) || state.auth.context,
        error:              state.app.error,
        loading:            state.app.loading,
        loadingSucceeded:   state.auth.loadingSucceeded,
        resetPasswordToken: getUrlParameter( 'rpt' ),
        token:              state.auth.token,
        username:           state.auth.username,
        userSettings:       state.userSettings
    };

};

const mapDispatchToProps = dispatch => {

    return {
        onDismissError:            () => dispatch( dismissError() ),
        onDismissLoadingSucceeded: () => dispatch( dismissLoadingSucceeded() ),
        onIsLoading:               () => dispatch( isLoading( false ) ),
        onLogout:                  ( context, token ) => dispatch( logout( context, token ) )
    };

};

export default connect( mapStateToProps, mapDispatchToProps )( App );